import {
  protectedDeleteWithBody,
  protectedGet,
  protectedPatch,
  protectedPost,
} from "./restUtil";
import * as _ from "underscore";

export function fetchInstructors(args, onSuccess, onError) {
  return protectedGet(
    "/instructors",
    args,
    function (resp) {
      if (!resp || !resp.list) {
        return onError("invalid response structure");
      }

      const instructors = [];
      _.each(resp.list, s => {
        instructors.push({
          //todo add
          // "degrees": [],
          // "avatar": "https://talaera.bookalope.net/api/user/8266b2e0336541378d80e54475d2e399/profile/avatar",
          id: s.id,
          profile: {
            first_name: s.first_name,
            last_name: s.last_name,
            timezone: {
              id: s.timezone.id,
              utc_offset: s.timezone.utc_offset,
            },
            address: {
              city: s.city,
              country: s.country,
            },
          },
        });
      });

      return onSuccess({ list: instructors });
    },
    onError
  );
}

export function fetchInstructor(args, onSuccess, onError) {
  return protectedGet(
    "/instructor/" + args.id,
    undefined,
    resp => {
      if (!resp) {
        return onError && onError("invalid response");
      }
      // TODO change the server to return required response structure

      const instructor = {
        id: resp.id,
        profile: {
          first_name: resp.profile.first_name,
          email: resp.profile.email,
          timezone: {
            id: resp.profile.timezone.id,
            utc_offset: resp.profile.timezone.utc_offset,
          },
          address: {
            city: resp.profile.address.city,
            country: resp.profile.address.country,
          },
        },
      };

      return onSuccess && onSuccess({ participant: instructor });
    },
    onError
  );
}

export function fetchInstructorAvailableSessions(args, onSuccess, onErrors) {
  return protectedGet(
    "/instructor/" + args.student_id + "/sessions",
    undefined,
    function (resp) {
      if (!resp || !resp.list) {
        return onErrors && onErrors("invalid response structure");
      }

      const sessions = resp;

      //todo add session params

      return onSuccess(sessions);
    },
    onErrors
  );
}

export function fetchInstructorAggregatedSessions(args, onSuccess, onErrors) {
  return protectedGet(
    "/instructor/" +
      args.user_id +
      "/sessions/aggregated?" +
      "from=" +
      args.from +
      "&to=" +
      args.to,
    undefined,
    function (resp) {
      if (!resp || !resp.list) {
        return onErrors && onErrors("invalid response structure");
      }

      const sessions = [];

      /*_.each(resp.list, (s) => {
      sessions.push({
        scheduled: s,
        type: "available-session"
      })
    });
    */
      return onSuccess({
        args: args,
        resp: sessions,
      });
    },
    onErrors
  );
}

export function fetchInstructorProfile(args, onSuccess, onError) {
  protectedGet("/instructor", undefined, onSuccess, onError);
}

export function getSalary(args, onSuccess, onError) {
  fetchInstructorProfile(
    undefined,
    resp => {
      return onSuccess && onSuccess(resp.salary);
    },
    onError
  );
}

export function fetchInstructorTags(args, onSuccess, onError) {
  protectedGet("/instructor/tags", undefined, onSuccess, onError);
}

export function updateInstructor(args, onSuccess, onError) {
  return protectedPatch("/instructor", args, onSuccess, onError);
}

export function getTags(args, onSuccess, onError) {
  return protectedGet(
    "/instructor/tags",
    {
      instructor_id: args.instructor_id,
    },
    onSuccess,
    onError
  );
}

export function addTag(args, onSuccess, onError) {
  return protectedPost(
    "/instructor/tags",
    {
      instructor_id: args.instructor_id,
      tags: args.tags,
    },
    onSuccess,
    onError
  );
}

export function removeTag(args, onSuccess, onError) {
  return protectedDeleteWithBody(
    "/instructor/tags",
    {
      instructor_id: args.instructor_id,
      tags: args.tags,
    },
    onSuccess,
    onError
  );
}
